/**
 * Formats milliseconds into a date string with an apostrophe in the year, in the format "17 Aug ′24 01:05 PM"
 * */
export const formatMillisecondsToDateWithApostrophe = (
  milliseconds: number,
  options: { hasTime?: boolean } = { hasTime: false },
) => {
  const { hasTime } = options;
  const date = new Date(milliseconds);

  const formatter = new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: 'short',
    year: '2-digit',
    ...(hasTime && {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    }),
  });

  const formattedDate = formatter.format(date);
  const [day, month, year, time, ampm] = formattedDate.split(' ');

  const timePart = hasTime && time && ampm ? ` ${time} ${ampm.toUpperCase()}` : '';

  return `${day} ${month} ′${year}${timePart}`;
};
